// Uploaded datasource files used to be served by an unauthenticated route,
// `GET /admin/v1/public/datasources/files/*`, and that URL was baked into every
// indexed record and into every citation we persisted. The route is gone (#2758),
// but those URLs are still sitting in `uploads_*` records and in chat history, so
// every read path has to recognise and drop them.
const LEGACY_UPLOAD_FILE_URL_PATH = '/admin/v1/public/datasources/files/';

export function isLegacyUploadFileUrl(url?: string): boolean {
  return !!url && url.includes(LEGACY_UPLOAD_FILE_URL_PATH);
}

const UPLOADS_COLLECTION_PREFIX = 'uploads_';

/** The sync collection holding an uploads datasource's indexed records. */
export function getUploadsCollectionName(datasourceId: string): string {
  return `${UPLOADS_COLLECTION_PREFIX}${datasourceId}`;
}

/**
 * Whether a name is a well-formed uploads collection. Callers resolving a collection
 * name that came from stored data must check this before handing it to Mongo — stored
 * data is only as trustworthy as whatever wrote it.
 */
export function isUploadsCollectionName(name: string): boolean {
  return /^uploads_[A-Za-z0-9_-]+$/.test(name);
}
